var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"no-underline inline-flex",attrs:{"to":_vm.localizedRoute('/'),"title":_vm.$t('Home Page')}},[_c('img',{attrs:{"width":_vm.width,"height":_vm.height,"src":"/assets/kultowy.svg","alt":_vm.$t(_vm.defaultTitle)}})])}
var staticRenderFns = []

export { render, staticRenderFns }